import { Instance } from 'mobx-state-tree'
import { LiveEventModelBase } from './LiveEventModel.base'

/* The TypeScript type of an instance of LiveEventModel */
export interface LiveEventModelType extends Instance<typeof LiveEventModel.Type> {}

/* A graphql query fragment builders for LiveEventModel */
export { selectFromLiveEvent, liveEventModelPrimitives, LiveEventModelSelector } from './LiveEventModel.base'

/**
 * LiveEventModel
 */
export const LiveEventModel = LiveEventModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
